// extracted by mini-css-extract-plugin
module.exports = {"modal__name":"styles_modal__name__3c5Gm","modal__button":"styles_modal__button__2NYuw","form":"styles_form__2oj3A"};